<app-base-action-modal
  modalTitle="Image Cropping"
  i18n-modalTitle
  primaryLabel="Apply Cropping"
  i18n-primaryLabel
  secondaryLabel="Discard Upload"
  i18n-secondaryLabel
  (closeClicked)="discardUpload()"
  (secondaryClicked)="discardUpload()"
  (primaryClicked)="confirmCroppedImage()">
  <div class="d-flex justify-content-center">
    <div class="cropper-container">
      <image-cropper
        [imageFile]="imageFile"
        [maintainAspectRatio]="true"
        [aspectRatio]="4 / 3"
        format="png"
        (imageCropped)="imageCropped($event)" />
    </div>
  </div>
</app-base-action-modal>
